import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router';

import '../../../public/css/media/_modal-otp.scss';

class TNCModal extends Component {
  state = {
    checkAgree: false,
    termsBottom: false,
    termReachedBottom: false
  }

  handleOnScroll(e) {
    const bottom = Math.round(e.target.scrollHeight - e.target.scrollTop) <= e.target.clientHeight + 2;
    if (bottom) {
      this.setState({ 
        termsBottom: true,
        termReachedBottom: true
      })
    } else {
      this.setState({ termsBottom: false })
    }
  }

  handleClickContinue() {
    this.setState({
      checkAgree: false,
      termsBottom: false,
      termReachedBottom: false
    })
    this.props.continue();
  }

  render () {
    if (this.props.modalClosed && this.state.termReachedBottom) {
      this.setState({
        checkAgree: false,
        termsBottom: false,
        termReachedBottom: false
      })
    }
    return (
      <Modal show={this.props.show} onHide={this.props.close} autoFocus={true} dialogClassName="custom-modal bfm-terms-modal" style={{ 'padding': '1px',  }}>
        <Modal.Header closeButton style={{ background: '#F9F9F9', textAlign: 'center' }}>
          <Modal.Title style={{ padding: '20px', width: '100%', fontWeight: 600 }}>BUY-FOR-ME TERMS OF SERVICE</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-padding">
          <section className="modal-body bfm-modal-content" style={{ height: '400px', overflow: 'auto', margin: '20px 0px', padding: '0px 20px' }} onScroll={(e) => this.handleOnScroll(e)}>
            <div className="control">
              <p>This Buy-For-Me Terms of Service shall supplement the ShippingCart Terms and Conditions accessible <Link to="/terms-conditions" target="_blank">here</Link>.</p>
              You may use our Buy-For-Me service for a nominal fee based on your total item cost including local delivery fee and transaction fee per checkout per store. Our warehouse partners will place the order for you, according to the instructions you provide, and pay for the purchase on your behalf. You acknowledge that your use of the Buy-For-Me service is governed by these Terms of Service and the Terms and Conditions of ShippingCart. By placing a Buy-For-Me order with us, You are agreeing to be bound by the Terms of Service set forth below.
            </div>
            <ul style={{ listStyle: 'none' }}>
              <li>Section 1: Buy-For-Me Service Orders
                <ul style={{ listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' }}>
                  <li>
                    In order to avail of the Buy-For-Me service, You must first complete the Buy-For-Me order form. The instructions You submit on the Buy-For-Me order form must specify the exact Product to be purchased, including the item name, website link, and item details such as quantity, size, color, etc. Any product questions should be addressed to the merchant before your submission. We will not facilitate any communications between you and the merchant.  Upon submission of the order form, you warrant that the information provided therein is accurate and complete. As used in this document, “merchant” shall refer to the merchant, vendor, or seller from whom You wish to order and purchase Products from.
                  </li>
                  <li>
                    You understand that it is your sole responsibility to ensure the accuracy of the instructions and item details submitted to us through the Buy-For-Me order form. ShippingCart will not be liable to You or any other party for any loss, damage, costs, or purchase of Products arising from any information (including incorrect, incomplete, or inaccurate information) provided by You in the Buy-For-Me order form.
                  </li>
                  <li>
                    We reserve the right to refuse Your Buy-For-Me order in the following instances:
                    <ul style={{ listStyle: 'decimal', padding: '0px 0px 0px 20px' }}>
                      <li>
                        You fail to supply complete information in the order form;
                      </li>
                      <li>
                        The order includes a Product coming from an auction;
                      </li>
                      <li>
                        The order contains a prohibited item that we cannot ship or otherwise constitutes an Unacceptable Shipment under the ShippingCart Terms and Conditions; or
                      </li>
                      <li>
                        Any Product in the order is out-of-stock.
                      </li>
                    </ul>
                    When an order is refused for whatever reason, Customer Care will reach out via email to inform You.
                  </li>
                  <li>
                    A Buy-For-Me service order cannot be changed or cancelled once You have paid the PayPal invoice link. By placing an order, You are deemed to have accepted our Terms of Service and you assume full responsibility for the product fees, shipping costs to our warehouse and service fee associated with the orders you place.
                  </li>
                  <li>
                    If we receive a chargeback notification regarding Your payment made via PayPal invoice link, Your account will be permanently suspended and the items we have purchased on Your behalf will be disposed of or sold by us without incurring any liability whatsoever to You or any other party. ShippingCart will not approve any disputes submitted via PayPal regarding your order.
                  </li>
                  <li>
                    If ShippingCart, in its sole discretion, deems that items purchased on your behalf is a result of fraudulent activity or related to a restricted or prohibited business, or linked to any illegal activity under applicable laws, ShippingCart reserves the right to take any action that it may deem necessary under the circumstances without further notice to You or any other party, including but not limited to, suspending your account, marking the item as restricted to prohibit send out, and reporting such activity to the source and/or local authority or governing body in which You reside in.
                  </li>
                </ul>
              </li>
              <li>Section 2: Buy-For-Me Service Fee
                <ul style={{ listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' }}>
                  <li>
                    For items that are $300 and above - The Buy-For-Me service fee is 5% of the total item cost including the local delivery fee with a 5% transaction fee per checkout per store.
                  </li>
                  <li>
                    For items that are $299.99 and below - The Buy-For-Me service fee is fixed at USD15 with a 5% transaction fee per checkout per store.
                  </li>
                  <li>
                    The 5% transaction fee is computed from the total item cost including the local delivery fee plus the applicable Buy-For-Me service fee. This transaction fee applies per checkout per store.
                  </li>
                  <li>
                    The Buy-For-Me Service fee will be billed in USD via PayPal invoice link. The Customer Care Team will send the PayPal invoice link by email.
                  </li>
                </ul>
              </li>
              <li>Section 3: Returns, Refunds, Exchanges
                <ul style={{ listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' }}>
                  <li>
                    For paid orders, a refund can be processed if a Product in the order is out-of-stock, provided that the refund amount will only cover the item/s that we cannot purchase. We will search for a similar Product to replace the item that is out-of-stock if you have indicated this as your preference on the Buy-For-Me order form. In the event that an item/s in the order is out-of-stock, Customer Care will reach out via email to inform you.
                  </li>
                  <li>
                    We are not responsible for any errors of the merchants in fulfillment of orders or otherwise. Arrangements with the merchant for any requests for returns, refunds or exchange of items must be addressed to the merchant directly in accordance with the merchant’s terms and policies, including their policies on who will shoulder the return fees. We are also not responsible for any and all defects in the Products unless the same have been caused due to our direct acts or omissions.
                  </li>
                  <li>
                    We do not facilitate any exchanges for Products. We will facilitate the return delivery of item(s) ordered from the merchant while the goods are still at the ShippingCart warehouse. You agree to shoulder applicable return charges.
                  </li>
                </ul>
              </li>
              <li>Section 4: Limitation of Liability 
                <ul style={{ listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' }}>
                  <li>
                    You understand and acknowledge that the quality of the Products purchased from merchants through our Buy-For-Me service and the accuracy of the claims regarding such Products are the sole responsibility of the manufacturer and/ or distributor of the Products. We do not warrant, represent or guarantee the quality of the Products or that the claims made by the manufacturer and/ or distributor are accurate. To the full extent permissible by applicable law, We disclaim all warranties (whether express or implied) including but not limited to, that the Products are merchantable, will meet Your function and/ or requirements or be fit for a particular purpose. We shall not be responsible for any loss or injury or damage incurred as a result of your use of the Products, or the failure of the Products to conform with any warranties made by the merchant, if any.
                  </li>
                  <li>
                    The merchants are third parties and the transactions made between you and the said merchants and/or between the warehouse operators and the merchants shall be governed by the terms of service of said merchants. We further disclaim any and all warranties related to the merchants including the latter’s authorities, licenses, and business operations. You understand that the Product or service warranties granted by the merchants to the warehouse operators, if any, may not be passed on or assigned to You. We shall not be liable for losses or damage suffered by You arising from or reasonably related to the foregoing. 
                  </li>
                </ul>
              </li>
              <li>Section 5: General
                <ul style={{ listStyle: 'lower-alpha', padding: '0px 0px 10px 20px' }}>
                  <li>
                    We reserve the right to amend, delete, or add to these Terms of Service from time to time without giving notice and with immediate effect. Your continued use of the Buy-For-Me service shall signify your acceptance of the Terms of Service as amended.
                  </li>
                  <li>
                    We reserve the right to modify or terminate the Buy-For-Me service for any reason, without notice at any time.
                  </li>
                  <li>
                    We reserve the right to refuse service to anyone for any reason at any time. We further reserve the right to modify the fees we charge for this service. You shall be notified in case we implement any changes to the fees. 
                  </li>
                  <li>
                    Any dispute arising out of or in connection with a Buy-For-Me order shall be resolved in accordance with the ShippingCart Terms and Conditions. 
                  </li>
                </ul>
              </li>
            </ul>
          </section>
          <div style={{display: 'flex'}}>
            <input
              id='checkbox'
              data-id='checkbox'
              onChange={() => this.setState({ checkAgree: !this.state.checkAgree })}
              value={this.state.checkAgree}
              type="checkbox"
              style={{ width: '35px', height: '17px' }}
              disabled={!this.state.termsBottom && !this.state.termReachedBottom ? "disabled" : ""}
            />
            <label id="checkbox" htmlFor='checkbox' style={{ fontWeight: 'normal', }}>Ticking this box means that you have read, understood, and agree to our Terms of Service.</label>
          </div>
          <div className="modal-footer" style={{ textAlign: 'center', padding: '15px 29px' }}>
            <button type="submit" onClick={() => this.handleClickContinue()} className="btn btn-register" style={{ width: '180px', background: '#AA0E0E', borderRadius: '20px', border: '1px solid #AA0E0E', color: '#FFF' }} disabled={!this.state.checkAgree}>
              CONTINUE
            </button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
export default TNCModal;


/** WEBPACK FOOTER **
 ** ./src/components/BuyForMe/TNCModal.js
 **/